import {Component, DestroyRef, inject, ChangeDetectionStrategy} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

import {AuthService} from 'src/app/all-modules/core/service/auth.service';

interface DialogContext<T = unknown> {
  completeWith(value: T): void;
  data?: unknown;
}

@Component({
  selector: 'app-session-expiry',
  templateUrl: './session-expiry.component.html',
  styleUrl: './session-expiry.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SessionExpiryComponent {
  private readonly context =
    inject(POLYMORPHEUS_CONTEXT) as DialogContext<boolean>;

  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  currentValue = '';

  constructor() {
    this.authService.timeDisplays
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.currentValue = result;

        if (result === '00:0' || result === '00:00') {
          this.authService.logout();
          this.closeDialog(true);
        }
      });
  }

  closeDialog(confirmed: boolean): void {
    localStorage.setItem('sessionout', '1');
    this.context.completeWith(confirmed);
  }
}